import { BillingAddress } from '@peerless/data-access/api';
import { Address, ANetCardData, CreditCardInput } from './types';
import cardValidator from 'card-validator';

const EXP_DATE_DELIMITER = ' / ';

export const composeTokenizeInput = (input: CreditCardInput): ANetCardData => {
  return {
    cardNumber: input.cardNumber.replace(/\s+/g, ''),
    month: input.expiryDate.split(EXP_DATE_DELIMITER)[0],
    year: input.expiryDate.split(EXP_DATE_DELIMITER)[1],
    cardCode: input.cvv,
    fullName: input.cardHolderName,
  };
};

export const formatCardNumber = (value: string): string => {
  const card = cardValidator.number(value).card;

  if (card && card.type === 'american-express') {
    return value.replace(/(\d{4})(\d{6})(\d{5})/, '$1 $2 $3').slice(0, 17);
  }

  return value
    .replace(/\D/g, '')
    .slice(0, 16)
    .replace(/(.{4})/g, '$1 ')
    .trim();
};

export const formatExpiryDate = (value: string): string => {
  // Remove non-numeric characters
  const numericValue = value.replace(/\D/g, '');

  // Limit to four numeric characters
  const formattedValue = numericValue.slice(0, 4);

  // Add the '/' separator after the first two characters
  if (formattedValue.length > 2) {
    return formattedValue.slice(0, 2) + EXP_DATE_DELIMITER + formattedValue.slice(2);
  } else {
    return formattedValue;
  }
};

export const composeAuthorizeNetAddress = (address?: Address): BillingAddress | undefined => {
  if (!address) {
    return undefined;
  }
  return {
    firstName: address.firstName,
    lastName: address.lastName,
    address: (address.address1 + ' ' + address.address2).trimEnd(),
    city: address.city,
    state: address.state,
    zip: address.zip,
  };
};
